<!-- Styles -->
<template>
  <div id="app">
    <!-- Header -->
    <AppHeader></AppHeader>
    <!-- Main Content -->
    <main>
      <router-view/>
    </main>
  </div>
</template>

<!-- Scripts -->
<script>
import AppHeader from '@/components/AppHeader'
export default {
  name: 'App',
  components: { AppHeader }
}
</script>

<!-- Styles -->
<style lang="scss" src="./assets/scss/fmixlabFont.scss"></style>
<style lang="scss" src="./App.scss"></style>



// WEBPACK FOOTER //
// src/App.vue